.toggle {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	cursor: pointer;
}

.toggle[data-disabled] {
	cursor: not-allowed;
	opacity: 0.5;
}

.text {
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
}

.label {
	color: var(--content-primary);
}

.description {
	color: var(--content-tertiary);
}

.track {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	width: 36px;
	height: 20px;
	padding: 2px;
	border-radius: 10px;
	background-color: var(--border-hover);
	transition: background-color 200ms ease;
}

.toggle[data-selected] .track {
	background-color: var(--background-secondary);
}

.toggle[data-focus-visible] .track {
	outline: var(--focus-outline);
	outline-offset: 2px;
}

.thumb {
	width: 16px;
	height: 16px;
	border-radius: 50%;
	background-color: var(--background-primary);
	transition: transform 200ms ease;
}

.toggle[data-selected] .thumb {
	transform: translateX(16px);
}
